import { stringify } from 'qs';
import {URL_API} from "../../url.config";
import {request} from "../../utils/apiUtils";
let YearController = {
    getListYear: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    searchByType: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/search-by-type?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },

    getDetail: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/detail/${payload.id}`,
            method: 'GET',
        }, callback)
    },
    block: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/block/${payload.id}`,
            method: 'GET'
        }, callback)
    },
    unblock: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/unblock/${payload.id}`,
            method: 'GET'
        }, callback)
    },
    delete: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/delete/${payload.id}`,
            method: 'GET'
        }, callback)
    },
    all: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/all`,
            method: 'GET'
        }, callback)
    },
    setCurrentYear: (yearId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/set-current/${yearId}`,
            method: 'GET'
        }, callback)
    },
    // Pha 2 — Kích hoạt năm học mới: lên lớp hàng loạt (flip currentClassRoom theo dự kiến),
    // tốt nghiệp HS cuối cấp, khóa năm cũ. Khác set-current (chỉ đổi năm hiển thị).
    activate: (yearId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/activate/${yearId}`,
            method: 'GET'
        }, callback)
    },
    // Mở (OPEN) hoặc đóng băng (LOCKED) một năm học.
    setYearStatus: (yearId, status, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/set-status/${yearId}/${status}`,
            method: 'GET'
        }, callback)
    },
    getCurrentYear: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/current-year`,
            method: 'GET'
        }, callback)
    },
}
export default YearController
